import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=0d7c2d29&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=0d7c2d29&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c2d29",
  null
  
)

export default component.exports